import { render, staticRenderFns } from "./DisplayDatamap.vue?vue&type=template&id=c61518a2&scoped=true&"
import script from "./DisplayDatamap.vue?vue&type=script&lang=js&"
export * from "./DisplayDatamap.vue?vue&type=script&lang=js&"
import style0 from "./DisplayDatamap.vue?vue&type=style&index=0&id=c61518a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61518a2",
  null
  
)

export default component.exports